import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { use as _$use } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<p class=shell__notice>LOADING…`),
  _tmpl$2 = /*#__PURE__*/_$template(`<p class=shell__notice>The baked assets could not be loaded. Run <code>bun run bake</code> and reload.`),
  _tmpl$3 = /*#__PURE__*/_$template(`<footer class=shell__footer><a href=/assets>asset review</a><a href=/duel>multiplayer`),
  _tmpl$4 = /*#__PURE__*/_$template(`<main class=shell><canvas class=shell__screen aria-label="Red Baron main menu">`);
/**
 * `/` — the game's shell, as Red Baron shipped it (AD-009). One canvas, a
 * logical 320×200 frame, the original's own artwork and bitmap fonts, and the
 * original's intro ahead of it on first entry. Nothing here says "Red Opus":
 * the product is Red Baron.
 *
 * The one departure from the original's boot is the start gate. `PS.EXE` came
 * up from DOS with the sound card already its own; a browser hands audio over
 * only after a real user gesture, and an intro started on route load would
 * play mute and would begin sequencing while its screens and songs were still
 * on the wire. So the shell holds on the black screen the script opens with,
 * takes the first input as that gesture, unlocks audio, waits out the preload,
 * and only then starts the clock — `intro/start-gate.ts` is the rule,
 * `intro/gate-screen.ts` is what it looks like, `shell-runtime.ts` runs it.
 *
 * This component is only the DOM around the frame.
 */

import { useNavigate } from "@solidjs/router";
import { createSignal, onCleanup, onMount, Show } from "solid-js";
import "./shell.css";
import { createShellRuntime } from "./shell-runtime.ts";
import { observeViewMetrics } from "../three/view-metrics.ts";
export function Shell() {
  const navigate = useNavigate();
  const runtime = createShellRuntime(navigate);
  const [view, setView] = createSignal(runtime.view());
  runtime.subscribe(setView);
  let canvas;
  function onKeyDown(event) {
    runtime.keyDown(event);
  }
  function onVisibilityChange() {
    runtime.visibilityChanged(document.hidden);
  }
  onMount(() => {
    runtime.mount(canvas);
    // Size and density both, for `ScreenShell.tsx`'s reason.
    const stopViewMetrics = canvas ? observeViewMetrics(canvas, () => runtime.repaint()) : undefined;
    window.addEventListener("keydown", onKeyDown);
    document.addEventListener("visibilitychange", onVisibilityChange);
    onCleanup(() => {
      stopViewMetrics?.();
      window.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      runtime.dispose();
    });
  });
  return (() => {
    var _el$ = _tmpl$4(),
      _el$2 = _el$.firstChild;
    _el$2.$$touchstart = () => runtime.touchStart();
    _el$2.$$pointerdown = event => runtime.pointerDown(event);
    _el$2.$$pointermove = event => runtime.pointerMove(event);
    _$use(element => canvas = element, _el$2);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return _$memo(() => view().status === "loading")() && !view().prompting;
      },
      get children() {
        return _tmpl$();
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return view().status === "failed";
      },
      get children() {
        return _tmpl$2();
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return view().phase === "menu";
      },
      get children() {
        return _tmpl$3();
      }
    }), null);
    return _el$;
  })();
}
_$delegateEvents(["pointermove", "pointerdown", "touchstart"]);